import React, { FC, useEffect, useState } from 'react';
import { useStyles } from './styles';
// import LogoIcon from 'assets/darklogo.svg';
import sampleImg from '../../../assets/sample.svg';
import logoImage from '../../../assets/logo.svg';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';

const EndUserHeader: FC = () => {
  const {
    endUserSettingsFormStore: { getPortalSettings, endUserConfigSettings },
    notificationStore: { openNotification },
  } = useStore();
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const [imgSrc, setImgSrc] = useState<string>(logoImage);

  useEffect(() => {
    setImgSrc(
      !portalSettingsgetReq.isLoading && portalSettingsgetReq?.data?.companyLogo
        ? portalSettingsgetReq.data.companyLogo
        : sampleImg
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portalSettingsgetReq?.data?.companyLogo, portalSettingsgetReq.isLoading]);
  const classes = useStyles();

  return (
    <>
      <div className={classes.topBar}>
        <div className={classes.uploadLogo}>
          {/* <img src={LogoIcon} alt='' className={classes.logostyle} /> */}
          <a
            href={endUserConfigSettings?.companyUrl ? endUserConfigSettings.companyUrl : undefined}
            target='_blank'
            rel='noreferrer'
          >
            <>
              <div className={classes.uploadLogoPic}>
                {imgSrc !== undefined && <img src={imgSrc} alt={imgSrc !== undefined ? 'No Image' : 'Image'} />}
              </div>
            </>
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div>
            <a
              href={endUserConfigSettings?.companyUrl ? endUserConfigSettings.companyUrl : undefined}
              target='_blank'
              rel='noreferrer'
              className={classes.title}
            >
              {endUserConfigSettings?.companyName ? endUserConfigSettings?.companyName : ''}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default EndUserHeader;
